/* globals translation */

const lndaLabQuiz = () => {
  const initContactSupport = () => {
    const contactForm = document.querySelector('form.lab-quiz-contact-support');
    if (contactForm) {
      contactForm.addEventListener('submit', (event) => {
        event.preventDefault();

        const content = document.querySelector('.customer-not-approved-notification');
        content.classList.add('loading');
        const infoText = contactForm.querySelector('[name=information]');

        const payload = {
          action: 'lnda_lab_quiz_contact_support',
          info: infoText.value,
        };

        const customerIdField = document.querySelector('input[name="customer_id"]');
        if (customerIdField && customerIdField.value) {
          payload.customer_id = customerIdField.value;
        }

        const createAccount = document.querySelector('input[name="approve-create-account"]');
        if (createAccount && createAccount) {
          const emailInput = document.querySelector('input[name="customer-email"]');
          payload.create_account = true;
          payload.email = emailInput.value;
        }

        jQuery.post(translation.ajaxurl, payload, (response) => {
          content.innerHTML = response;
          content.classList.remove('loading');
        });
      });
    }
  };
  initContactSupport();


  const initEmailValidator = () => {
    const emailInput = document.querySelector('.lab-quiz input[name="customer-email"]');
    if (emailInput) {
      let checkUser = null;
      const isValidation = false;
      const startButton = document.querySelector('.email-validation-button');
      const customerIdField = document.querySelector('input[name="customer_id"]');
      // eslint-disable-next-line no-useless-escape
      const emailRegExs = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;

      emailInput.addEventListener('keyup', (event) => {
        event.preventDefault();

        if (isValidation) {
          return;
        }

        clearInterval(checkUser);

        if (String(emailInput.value).search(emailRegExs) !== -1) {
          checkUser = setTimeout(() => {
            const payload = {
              action: 'lnda_lab_quiz_validate_email',
              email: emailInput.value,
            };

            emailInput.classList.add('wait');
            emailInput.disabled = false;
            startButton.disabled = true;
            customerIdField.value = '';

            jQuery.post(translation.ajaxurl, payload, (response) => {
              emailInput.classList.remove('wait');
              emailInput.disabled = false;

              if (response.success && response.data.type !== 'user-not-found') {
                startButton.disabled = false;
              }

              const validationOutput = document.querySelector('.customer-email-validator-output');
              validationOutput.innerHTML = response.data.message;

              if (response.data.type === 'user-ready') {
                customerIdField.value = response.data.user_id;
              }

              if (response.data.type === 'user-not-found') {
                setTimeout(() => {
                  const checker = document.querySelector('input[name="approve-create-account"]');
                  if (checker) {
                    checker.addEventListener('change', () => {
                      if (checker.checked) {
                        startButton.disabled = false;
                      } else {
                        startButton.disabled = true;
                      }
                    });
                  }
                }, 20);
              }
            });
          }, 1000);
        }
      });
    }
  };
  initEmailValidator();


  const setActivePagination = () => {
    const paginationWrapper = document.querySelector('.pagination-steps');
    if (paginationWrapper) {
      const activeQuestion = document.querySelector('.lab-quiz-question.active');
      const activeId = activeQuestion.dataset.questionId;
      let paginationCounter = 1;

      const allPaginationSteps = Array.from(paginationWrapper.querySelectorAll('.pagination-step'));
      if (allPaginationSteps) {
        allPaginationSteps.forEach((step) => {
          step.classList.remove('active');
        });
      }

      while (paginationCounter <= parseInt(activeId, 0)) {
        const pagination = paginationWrapper.querySelector(`#quiz-pagination-step-${paginationCounter}`);
        pagination.classList.add('active');
        paginationCounter += 1;
      }
    }
  };

  const quizForm = document.querySelector('.lab-quiz');
  if (quizForm) {
    const questions = Array.from(quizForm.querySelectorAll('.lab-quiz-question'));

    questions.forEach((questionWrapper) => {
      const { questionId } = questionWrapper.dataset;

      const options = Array.from(questionWrapper.querySelectorAll(`input[name=question-${questionId}]`));
      options.forEach((option) => {
        option.addEventListener('change', (event) => {
          event.preventDefault();
          const quizForwardButton = questionWrapper.querySelector('.quiz-forward');
          quizForwardButton.classList.remove('disabled');
        });
      });

      const completeButton = questionWrapper.querySelector('.complete-quiz');
      if (completeButton) {
        completeButton.addEventListener('click', (event) => {
          event.preventDefault();
          const allAnswerInputs = Array.from(quizForm.querySelectorAll('input:checked:not(.ignore-me)'));
          const answers = [];

          if (allAnswerInputs) {
            allAnswerInputs.forEach((answer) => {
              answers.push(answer.value);
            });
          }

          const payload = {
            action: 'lnda_lab_quiz_submit',
            answers,
          };

          const customerIdField = document.querySelector('input[name="customer_id"]');
          if (customerIdField && customerIdField.value) {
            payload.customer_id = customerIdField.value;
          }

          const createAccount = document.querySelector('input[name="approve-create-account"]');

          if (createAccount && createAccount) {
            const emailInput = document.querySelector('input[name="customer-email"]');
            payload.create_account = true;
            payload.email = emailInput.value;
          }

          jQuery.post(translation.ajaxurl, payload, (response) => {
            const output = document.querySelector('.quiz-result-output');
            quizForm.classList.add('hidden');
            output.innerHTML = response;
            initContactSupport();
          });
        });
      }

      const startButton = questionWrapper.querySelector('.start-quiz');
      if (startButton) {
        startButton.addEventListener('click', (event) => {
          event.preventDefault();
          const pagination = quizForm.querySelector('.pagination-steps.hidden');
          if (pagination) {
            pagination.classList.remove('hidden');
          }
        });
      }

      const continueButton = questionWrapper.querySelector('.continue-quiz');
      if (continueButton) {
        continueButton.addEventListener('click', (event) => {
          event.preventDefault();
          const nextId = parseInt(questionId, 0) + 1;
          const nextQuestionWrapper = quizForm.querySelector(`.lab-quiz-question-${nextId}`);

          questionWrapper.classList.remove('active');
          nextQuestionWrapper.classList.add('active');
          setActivePagination();
        });
      }

      const goBackButton = questionWrapper.querySelector('.go-back');
      if (goBackButton) {
        goBackButton.addEventListener('click', (event) => {
          event.preventDefault();
          const prevId = parseInt(questionId, 0) - 1;
          const prevQuestionWrapper = quizForm.querySelector(`.lab-quiz-question-${prevId}`);

          questionWrapper.classList.remove('active');
          prevQuestionWrapper.classList.add('active');
          setActivePagination();
        });
      }

      const isLastQuestion = questionWrapper.querySelector('.is-last-question');
      if (isLastQuestion) {
        isLastQuestion.addEventListener('click', (event) => {
          event.preventDefault();
          const allAnswerInputs = Array.from(quizForm.querySelectorAll('input:checked:not(.ignore-me)'));
          const displayAnswers = document.querySelector('.quiz-summary ul');

          // Clear potential existing answers
          const existingAnswers = displayAnswers.querySelectorAll('.is-cloned');
          if (existingAnswers) {
            existingAnswers.forEach((existingAnswer) => {
              existingAnswer.remove();
            });
          }

          if (allAnswerInputs) {
            allAnswerInputs.forEach((checker) => {
              const { question, answer } = checker.dataset;
              if (question && answer) {
                const originalItem = displayAnswers.querySelector('.clone-me');
                const clonedItem = originalItem.cloneNode(true);
                clonedItem.className = 'is-cloned';
                clonedItem.querySelector('.question-here').innerText = question;
                clonedItem.querySelector('.answer-here').innerText = answer;
                displayAnswers.appendChild(clonedItem);
              }
            });
          }
        });
      }
    });
  }
};

if (document.querySelector('.lnda-lab-quiz-wrapper')) {
  lndaLabQuiz();
}
